import { Component, HostListener, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.reducer';
import { Device } from 'src/app/model/device';
import { EDeviceModel } from 'src/app/conf/device-models';
import { convertDbStandartIcon, convertOldIcon, DeviceIcon } from 'src/app/conf/device-icons';
import { TranslateService } from '@ngx-translate/core';
import { StandardPageLayout } from 'src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib';

@Component({
	selector: 'app-device-icon-standalone',
	templateUrl: './device-icon-standalone.component.html',
	providers: [],
})

export class DeviceIconStandaloneComponent implements OnInit {
	@Input() device: Device;

	maxLenghtStrMobile: number = 25;
	maxLenghtStrShort: number = 30;
	maxLenghtStrLong: number = 30;

	screenWidth: number;

	constructor(
		private store: Store<AppState>,
		private translate: TranslateService,
	) {
		this.initSelectors();
	}

	ngOnInit(): void {
		this.subscribeAll();
		this.onResize();
	}

	initSelectors(): void {
		// Store selectors

	}

	subscribeAll(): void {

	}

	// func used also in device-treetable
	generateIcon(device: Device): string {
		let icon = '';
		if (device.ModelId !== EDeviceModel.MultiIO) {
			icon = 'cm-' + DeviceIcon[device.ModelId];
		} else {
			icon = 'cm-' + device.IconName.toLowerCase() || 'cm-' + DeviceIcon[device.ModelId] || 'cm-device-gateway';
		}
		switch (icon) {
			case 'cm-undefined': {
				return convertDbStandartIcon(device.IconName);
			}
			default: {
				return convertOldIcon(icon);
			}
		}
	}

	getTruncate(str: string, lenght: string): string {
		if (this.onExtendedMobile()) {
			return str.slice(0, this.maxLenghtStrMobile) + (str.length > this.maxLenghtStrMobile ? '...' : '');
		}
		return lenght === 'long' ? str.slice(0, this.maxLenghtStrLong) + (str.length > this.maxLenghtStrLong ? '...' : '') : str.slice(0, this.maxLenghtStrShort) + (str.length > this.maxLenghtStrShort ? '...' : '');
	}

	// Design
	@HostListener('window:resize')
	onResize(): void {
		this.screenWidth = window.innerWidth;
	}

	layoutMarginResponsive(): string {
		return StandardPageLayout.layoutMarginResponsive(this.screenWidth);
	}

	onExtendedMobile(): boolean {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}
}
